var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHttps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8021_9163)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8021_9163",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0V48H48V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8021_9163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0H8C3.58172 0 0 3.58172 0 8V40C0 44.4183 3.58172 48 8 48H40C44.4183 48 48 44.4183 48 40V8C48 3.58172 44.4183 0 40 0Z",
    fill: "url(#paint0_linear_8021_9163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 20H30.25V17.7143C30.25 14.56 27.45 12 24 12C20.55 12 17.75 14.56 17.75 17.7143V20H16.5C15.1188 20 14 21.0229 14 22.2857V33.7143C14 34.9771 15.1188 36 16.5 36H31.5C32.8812 36 34 34.9771 34 33.7143V22.2857C34 21.0229 32.8812 20 31.5 20ZM24 30.2857C22.6188 30.2857 21.5 29.2628 21.5 28C21.5 26.7372 22.6188 25.7143 24 25.7143C25.3812 25.7143 26.5 26.7372 26.5 28C26.5 29.2628 25.3812 30.2857 24 30.2857ZM27.875 20H20.125V17.7143C20.125 15.7599 21.8624 14.1714 24 14.1714C26.1374 14.1714 27.875 15.7599 27.875 17.7143V20Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8021_9163",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8021_9163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHttps);
export default __webpack_public_path__ + "static/media/https.90baaf54a5fa04efc71b489ed6521702.svg";
export { ForwardRef as ReactComponent };